export type TabLabelsMessages = {
  generalInformationTabLabel: string;
  documentsTabLabel: string;
  businessDataTabLabel: string;
  bankAccountTabLabel: string;
};

export const TAB_LABELS_MESSAGES: TabLabelsMessages = {
  generalInformationTabLabel: "Informações",
  documentsTabLabel: "Documentos",
  businessDataTabLabel: "Dados Comerciais",
  bankAccountTabLabel: "Conta Bancária",
};
